import React from "react";
import "./CustomerServicePage.css";

const CustomerServicePage = () => {
  const handleCallClick = () => {
    window.location.href = "tel:+917007512120";
  };

  const handleWhatsAppClick = () => {
    window.location.href = "https://wa.me/919118063939";
  };

  const handleEmailClick = () => {
    window.location.href = "mailto:info@swasthmitra.com";
  };

  const handleCareersEmailClick = () => {
    window.location.href = "mailto:careers@swasthmitra.com";
  };

  return (
    <>
      <div className="customerServiceSection">
        <h2>🤝 We're Here to Help – SwasthMitra Customer Service</h2>
        <div className="customerServiceContent">
          <p>
            Your health is important — and so is your experience with us.
            At <strong>SwasthMitra</strong>, we're committed to delivering <strong>exceptional customer support</strong> that's friendly, fast, and always focused on your well-being.
          </p>
          <p>
            Whether you have a question about your order, need help with a prescription, or just want guidance — we're just a call, click, or message away.
          </p>

          <hr />

          <h3>🔹 How Can We Assist You Today?</h3>

          <div className="serviceCategory">
            <h4>📦 <em>Order & Delivery Support</em></h4>
            <ul>
              <li>Track your order status</li>
              <li>Change or cancel an order</li>
              <li>Report a late or missing delivery</li>
            </ul>
            <div className="categoryNote">
              <p><strong>Response time:</strong> Within 24 hours</p>
            </div>
          </div>

          <div className="serviceCategory">
            <h4>💊 <em>Prescription Help</em></h4>
            <ul>
              <li>Upload prescriptions easily via WhatsApp or email</li>
              <li>Get help verifying or updating your prescription</li>
              <li>Understand how to use your medicines correctly</li>
            </ul>
            <div className="categoryNote">
              <p><strong>Note:</strong> We only accept valid prescriptions from licensed medical practitioners.</p>
            </div>
          </div>

          <div className="serviceCategory">
            <h4>🔁 <em>Returns & Refunds</em></h4>
            <ul>
              <li>Easy return policy for damaged or incorrect items</li>
              <li>Refunds processed within 5–7 working days</li>
              <li>Clear communication at every step</li>
            </ul>
            <div className="categoryNote">
              <p><strong>Important:</strong> Medicines once opened or used cannot be returned for safety reasons.</p>
            </div>
          </div>

          <div className="serviceCategory">
            <h4>🧾 <em>Invoices & Payments</em></h4>
            <ul>
              <li>Download invoices from your account</li>
              <li>Help with failed or duplicate transactions</li>
              <li>Secure payment gateway assistance</li>
            </ul>
          </div>

          <div className="serviceCategory">
            <h4>🛡 <em>Privacy & Packaging</em></h4>
            <ul>
              <li>Discreet packaging for personal and sensitive products</li>
              <li>100% confidential customer information handling</li>
              <li>Compliant with all data protection regulations</li>
            </ul>
          </div>

          <hr />

          <div className="contactSection">
            <h3>🔹 Contact Our Support Team</h3>
            
            <div className="contactMethod">
              <h4>📞 Call Us:</h4>
              <p>Customer Care: <button className="contactButton" onClick={handleCallClick}>+91-7007512120</button></p>
              <p className="contactHours">(Monday to Saturday | 9:00 AM – 7:00 PM)</p>
            </div>

            <div className="contactMethod">
              <h4>💬 WhatsApp Support:</h4>
              <button className="whatsappButton" onClick={handleWhatsAppClick}>Click Here to Chat</button>
              <p className="contactHours">(Quick replies during business hours)</p>
            </div>

            <div className="contactMethod">
              <h4>📧 Email Us:</h4>
              <p>General Support: <button className="contactButton" onClick={handleEmailClick}>info@swasthmitra.com</button></p>
              <p>Careers: <button className="contactButton" onClick={handleCareersEmailClick}>careers@swasthmitra.com</button></p>
            </div>
          </div>

          <hr />

          <div className="faqSection">
            <h3>🙋‍♂ Frequently Asked Questions (FAQs)</h3>
            
            <div className="faqItem">
              <p className="faqQuestion">Q. How long does delivery take?</p>
              <p className="faqAnswer">A: Most orders are delivered within 2–5 working days depending on your location.</p>
            </div>
            
            <div className="faqItem">
              <p className="faqQuestion">Q. Is it safe to order medicines online?</p>
              <p className="faqAnswer">A: Absolutely. We source only from licensed suppliers and follow strict verification protocols.</p>
            </div>
            
            <div className="faqItem">
              <p className="faqQuestion">Q. What if I receive the wrong item?</p>
              <p className="faqAnswer">A: No worries — just contact us, and we'll arrange a pickup and replacement ASAP.</p>
            </div>
            
            <div className="faqItem">
              <p className="faqQuestion">Q. Can I order without a prescription?</p>
              <p className="faqAnswer">A: For OTC (over-the-counter) products, yes. But prescription drugs require a valid prescription.</p>
            </div>
            
            <div className="faqItem">
              <p className="faqQuestion">Q. Are your packages discreet?</p>
              <p className="faqAnswer">A: 100%. Your privacy is our priority, especially for personal health products.</p>
            </div>
          </div>

          <hr />

          <div className="closingSection">
            <h3>🧡 Thank You for Trusting SwasthMitra</h3>
            <p>
              We're proud to be your health partner.
              Our goal is simple: to serve you with honesty, care, and dedication — every time you shop with us.
            </p>
            <div className="ctaButtons">
              <button className="whatsappButton" onClick={handleWhatsAppClick}>Start a WhatsApp Chat</button>
              <button className="emailButton" onClick={handleEmailClick}>Send Us an Email</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerServicePage;